export default __webpack_public_path__ + "static/media/vous_opposer.a310958f.jpg";